import { route } from 'quasar/wrappers';
import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
  createMemoryHistory
} from 'vue-router';
import { Cookies } from 'quasar';
import routes from './routes';
import { AppAuthTokenKey, AUTH_ROUTE_NAME } from '@/consts';
import { isElectron } from '@/utils/appUtil';

export default route(({ ssrContext }: any) => {
  const isServer = process.env.SERVER;
  const cookies = isServer && ssrContext ? Cookies.parseSSR(ssrContext) : Cookies;

  // Use hash mode for Electron (file:// protocol), history mode for web
  // Detect Electron by checking if we're in a file:// protocol or if MODE is set
  const isElectronMode = isElectron()
  const createHistory = isServer
    ? createMemoryHistory
    : (isElectronMode ? createWebHashHistory : createWebHistory);


  const Router = createRouter({
    scrollBehavior: (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition;
      }
      return { left: 0, top: 0 };
    },
    routes,
    history: createHistory(process.env.VUE_ROUTER_BASE)
  });

  Router.beforeEach((to, from, next) => {
    // Always allow navigation to signin (for logout flow)
    if (to.name === AUTH_ROUTE_NAME.SIGNIN) {
      next();
      return;
    }

    // In Electron, also check localStorage as cookies may not work
    let token = cookies.get(AppAuthTokenKey);
    if (isElectronMode && !token && typeof window !== 'undefined') {
      token = localStorage.getItem(AppAuthTokenKey);
    }

    // Redirect if user has token and trying to access guest-only route
    if (token && to.meta.onlyGuest) {
      next('/');
    } else {
      next();
    }
  });

  return Router;
});
